const t = {}

t.loading = '加载中...'

t.brand = {}
t.brand.lg = 'RPP后台管理系统'
t.brand.mini = 'RPP'

t.add = '新增'
t.delete = '删除'
t.deleteBatch = '删除'
t.update = '修改'
t.query = '查询'
t.export = '导出'
t.handle = '操作'
t.confirm = '确定'
t.cancel = '取消'
t.logout = '退出'
t.agree = '同意'
t.refuse = '拒绝'
t.prohibit = '禁用'
t.enable = '启用'
t.multiplexing = '复用'
t.save = '保存'

t.prompt = {}
t.prompt.title = '提示'
t.prompt.info = '确定进行[{handle}]操作?'
t.prompt.success = '操作成功'
t.prompt.failed = '操作失败'
t.prompt.deleteBatch = '请选择删除项'
t.prompt.logout = '注销当前账户吗?'

t.message = {}
t.message.logoutCancel = '放弃注销用户'

t.validate = {}
t.validate.required = '必填项不能为空'
t.validate.fillEng = '请填写字母'
t.validate.contentLong = '内容过长'
t.validate.format = '{attr}格式错误'
t.validate.choose = '请选择'

t.upload = {}
t.upload.text = '将文件拖到此处，或<em>点击上传</em>'
t.upload.tip = '只支持{format}格式文件！'
t.upload.button = '点击上传'
t.upload.selectFile = '选择文件'
t.upload.exceed = '上传超出限制'
t.upload.editCotentText = '请编辑内容'

t.datePicker = {}
t.datePicker.range = '至'
t.datePicker.start = '开始日期'
t.datePicker.end = '结束日期'
t.timePicker = {}
t.timePicker.start = '开始时间'
t.timePicker.end = '结束时间'

t.fullscreen = {}
t.fullscreen.prompt = '您的浏览器不支持此操作'

t.updatePassword = {}
t.updatePassword.title = '修改密码'
t.updatePassword.username = '账号'
t.updatePassword.password = '原密码'
t.updatePassword.newPassword = '新密码'
t.updatePassword.comfirmPassword = '确认密码'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = '确认密码与新密码输入不一致'

t.theme = {}
t.theme.d2 = 'D2Admin 经典'
t.theme.violet = '紫罗兰'
t.theme.line = '简约线条'
t.theme.star = '繁星'
t.theme.tomorrowNightBlue = 'Tomorrow Night Blue'
t.theme.list = {}
t.theme.list.button = '使用'
t.theme.list.buttonActive = '已激活'

t.layout = {}
t.layout.hello = '你好'
t.layout.logout = '注销'
t.layout.updatePassword = '修改密码'
t.layout.tooltip = {}
t.layout.tooltip.fullscreen = '全屏'
t.layout.tooltip.fullscreenActive = '退出全屏'
t.layout.tooltip.theme = '主题'
t.layout.tooltip.search = '搜索'
t.layout.search = {}
t.layout.search.placeholder = '搜索页面'
t.layout.search.tip1 = '您可以使用快捷键'
t.layout.search.tip2 = '唤醒搜索面板，按'
t.layout.search.tip3 = '关闭。'

t.layoutTab = {}
t.layoutTab.index = '首页'
t.layoutTab.noName = '未命名'

t.contentTabs = {}
t.contentTabs.closeCurrent = '关闭当前标签页'
t.contentTabs.closeOther = '关闭其它标签页'
t.contentTabs.closeAll = '关闭全部标签页'

/* 页面 */
t.notFound = {}
t.notFound.desc = '抱歉！您访问的页面<em>失联</em>啦...'
t.notFound.back = '上一页'
t.notFound.home = '首页'

t.login = {}
t.login.language = '语言'
t.login.motto = '时间是一切财富中最宝贵的财富'
t.login.form = {}
t.login.form.placeholderUsername = '用户名'
t.login.form.placeholderPassword = '密码'
t.login.form.placeholderCaptcha = '验证码'
t.login.form.textSubmitButton = '登录'
t.login.form.textForget = '忘记密码'
t.login.form.textSignUp = '注册用户'
t.login.footer = {}
t.login.footer.buttonHelp = '帮助'
t.login.footer.buttonPrivacy = '隐私'
t.login.footer.buttonClause = '条款'
t.login.copyright = {}
t.login.copyright.p1 = 'Copyright'
t.login.copyright.p2 = '2018 D2 Projects 开源组织出品'
t.login.copyright.p3 = '@FairyEver'
t.login.ruleMessage = {}
t.login.ruleMessage.username = '请输入用户名'
t.login.ruleMessage.password = '请输入密码'
t.login.ruleMessage.captcha = '请输入验证码'

/* 首页 */
t.home = {}
t.home.daily = '最新数据'
t.home.sales = '今日交易额'
t.home.numberOfOrder = '今日订单数'
t.home.numberOfUser ='所有用户数'
t.home.newUser = '今日新增用户数'
t.home.assetsIncome = '资产收益'
t.home.totalSales ='总交易额'
t.home.last30DaySales = '近一月交易额'
t.home.transactionManagement = '事务管理'
t.home.toDeliver = '待发货订单'
t.home.refund = '退款申请'
t.home.inventoryWarn = '库存预警'
t.home.inventoryWarnDefaultValue = '库存预警默认值'
t.home.inventoryQueryTime = '查询时间'

/*商品 */
t.product = {}
t.product.name = '商品名称'
t.product._ = '商品'
t.product._id = '商品ID'
t.product.list = '商品列表'
t.product.describe = '商品描述'
t.product.operation = '商品操作'
t.product.detailPage = '详情页面'
t.product.detailPageContent = '详情页面内容'
t.product.detailPageEdited = '已编辑'
t.product.detailPageUnedited = '未编辑'
t.product.skuType = '属性类型'
t.product.addRow = '添加一行'
t.product.info = '产品信息'
t.product.notice = '通知'
t.product.manufacturer = '制造商'
t.product.supplier = '供货商'
t.product.selectionReasons = '严选理由'
t.product.item = {}
t.product.item._ = '单品'
t.product.item.list = '单品列表'
t.product.item.keyword = '关键字'
t.product.item.activate = '已加入'
t.product.item.id = '单品ID'
t.product.item.name = '单品名称'
t.product.item.describe = '单品描述'
t.product.item.barCode = '条形码'
t.product.item.code = '单品代码'
t.product.item.stock = '库存'
t.product.item.price = '价格'
t.product.item.agentPrice = '代理价'
t.product.item.projectPrice = '工程价'
t.product.item.originalPrice = '原价'
t.product.item.operation = '单品操作'
t.product.item.off = '下架'
t.product.item.on = '上架'
t.product.item.copy = '复制'
t.product.item.freightCalculate = '运费计算'
t.product.item.freightCalculateValue = '运费计算值'
t.product.item.weight = '重量'
t.product.item.volume = '面积'
t.product.item.big = '大件'
t.product.item.priceAndStock = '价格 & 库存'
t.product.item.pictureAndVideo = '图片 & 视频'
t.product.item.picture = '封面图片 (1)'
t.product.item.detailPicture = '详情图片 (6)'
t.product.item.video = '视频 (1)'
t.product.item.extendValue = '扩展值'
t.product.item.colorPicker = '颜色选择器'
t.product.item.increment = '增量'
t.product.item.attribute = '属性'
t.product.item.attributeValue = '属性值'
t.product.item.attributeName = '属性名'
t.product.item.inventoryWarnValue = '库存预警值'
t.product.item.salesVolume = '销量'
t.product.item.shopLogo = '店铺Logo'
t.product.shelfTime = '上架时间(首发)'

/* 订单 */
t.order = {}
t.order.title = '订单'
t.order.id = '订单ID'
t.order.traceNo = '订单交易ID'
t.order.amount = '订单金额(฿)'
t.order.amountFlag = '฿'
t.order.status = '订单状态'

t.order.WC = '待审核'
t.order.WP = '待付款'
t.order.WS = '待发货'
t.order.WR = '待收货'
t.order.FINISH = '完成'
t.order.CANCEL = '取消'
t.order.REFUNDING = '退款中'
t.order.REFUNDED = '退款成功'
t.order.RETURNED = '已退货'
t.order.REJECTED = '已拒收'
t.order.userPhone = '用户号码'
t.order.paymentMethod = '支付方式'
t.order.cashPay = '现金支付'
t.order.onlinePay = '在线支付'
t.order.cod = '货到付款'
t.order.shippingMethod = '提货方式'
t.order.pickUp = '到店自提'
t.order.delivery = '物流配送'
t.order.time = '下单时间'
t.order.finishedTime = '完成时间'
t.order.payTime = '支付时间'
t.order.count = '数量'
t.order.toPay = '付款'
t.order.toShip = '发货'
t.order.finishOrder = '完成订单'
t.order.invoice = '开具发票'
t.order.cancelOrder = '取消订单'
t.order.detail = '详情'
t.order.party = '物流公司'
t.order.trackingNumber = '物流单号'
t.order.flashStatus = '状态'
t.order.expressNumber = '快递单号'
t.order.expressTime = '时间'
t.order.expressInfo = '信息'
t.order.zto = '中通'
t.order.companyName = '公司名称'
t.order.companyCode = '公司代码'
t.order.placeOrder = '下单'
t.order.payment = '支付'
t.order.deliver = '发货'
t.order.complete = '完成'
t.order.collector = '收款人'
t.order.collectAmount = '收款金额'
t.order.collectTime = '收款时间'
t.order.receivingInfo = '收货信息'
t.order.phone = '电话'
t.order.address = '地址'
t.order.zipCode = '邮编'
t.order.invoice = '发票'
t.order.electronic = '电子版'
t.order.paper = '纸质'
t.order.refund = '退款'
t.order.refundId = '退款ID'
t.order.agree = '同意'
t.order.refuse = '拒绝'
t.order.refundProduct = '退款商品'
t.order.refundType = '退款类型'
t.order.delivered = '到货'
t.order.processMethod = '处理方式'
t.order.refundReason = '退款原因'
t.order.refundRemarks = '退款说明'
t.order.receivableAmount = '应收金额(฿)'
t.order.receivedAmount = '已收金额(฿)'
t.order.remark = '订单备注'
t.order.refundState = '退款状态：退款完成'
t.order.refundId = '退款ID'
t.order.refundType = '退款类型'
t.order.refundMethod = '处理方式'
t.order.remarks = '退款原因'
t.order.refundReason = '退款说明'
t.order.goodsStatus = '到货'
t.order.refundTypeEXCHANGE = '换货'
t.order.refundTypeLEAKAGE = '漏发'
t.order.refundTypeREFUND = '退款'
t.order.goodsStatusDELIVERED = '是'
t.order.goodsStatusUNDELIVERED = '未到'
t.order.refundMethodREFUND = '退款'
t.order.refundMethodRETURN = '退货'
t.order.refundMethodREFUNDANDRETURN = '退货退款'
t.order.refundMethodREISSUED = '补发'
t.order.refundReasonNOTCONFORM = '描述不符'
t.order.refundReasonWRONGDELIVERY = '发错货'
t.order.refundReasonQUALITY = '质量问题'
t.order.refundReasonOTHER = '其它'
t.order.childOrderId = '子订单ID'
t.order.mechantName = '店铺名称'
t.order.productImage = '商品图片'
t.order.code = 'code'
t.order.productName = '商品名称'
t.order.productPrice = '商品售价'
t.order.productTotal = '数量'
t.order.productStatus = '状态'
t.order.operation = '操作'
t.order.shipTime = '发货时间'
t.order.viewLogistics='查看物流'
t.order.discountPrice = '折扣'
t.order.freightPrice = '运费'
t.order.productPrice = '商品总额'
t.order.subOrderDetail = '子订单详情'
t.order.coreOrderId = '总订单ID'
t.order.allDatail = '总订单详情'
t.order.walletPaid = '已收钱包金额'
t.order.codPrice = 'COD应收'
t.order.codPaid = 'COD实收'
t.order.onlinePaid = '线上支付已收'
t.order.rejectOrder = '拒收'
t.order.reasonCode = '原因Code'
t.order.reasonMsg = '原因'
t.order.Paymentvoucher='支付凭证'
t.order.FirstPaymentvoucher='首款支付凭证：'
t.order.Uploadtime='上传时间：'
t.order.ProofPaymentvoucher='尾款支付凭证：'

/* 统计 */
t.statistical = {}
t.statistical.type = '类型'
t.statistical.date = '日期'
t.statistical.amount = '订单金额(฿)'
t.statistical.orders = '订单数'
t.statistical.dailyReport = '日报'
t.statistical.monthlyReport = '月报'
t.statistical.annualReport = '年报'

/* 广告 */
t.advert = {}
t.advert.name = '广告名称'
t.advert.jumpType = '跳转类型'
t.advert.noJump = '不跳转'
t.advert.productItemDetail = '单品详情'
t.advert.share = '分享'
t.advert.classification = '分类'
t.advert.login = '登录'
t.advert.wallet = '钱包'
t.advert.buyfree = 'buyfree活动列表'
t.advert.buyfreeDetail = 'buyfree活动详情'
t.advert.activityId = '活动ID'
t.advert.productItemId = '单品ID'
t.advert.priority = '优先级'
t.advert.periods = '周期'
t.advert.ONCEADAY = '每日一次'
t.advert.EVERYTIME = '每次'
t.advert.ONLYONCE = '仅一次'
t.advert.effectiveDate = '有效日期'
t.advert.effective = '有效'
t.advert.activity = '品牌专场'
t.advert.merchant = '店铺'
t.advert.brand = '品牌'


/* 佣金 */
t.commission = {}
t.commission.userName = '用户名'
t.commission.newUserName = '新用户名'
t.commission.oldUserName = '老用户名'
t.commission.newUserCountry = '新用户国家号'
t.commission.oldUserCountry = '老用户国家号'
t.commission.presentMoney = '佣金(฿)'
t.commission.status = '佣金状态'

t.menu = {}
t.menu.name = '名称'
t.menu.icon = '图标'
t.menu.type = '类型'
t.menu.type0 = '菜单'
t.menu.type1 = '按钮'
t.menu.sort = '排序'
t.menu.url = '路由'
t.menu.permissions = '授权标识'
t.menu.permissionsTips = '多个用逗号分隔，如：sys:menu:save,sys:menu:update'
t.menu.parentName = '上级菜单'
t.menu.parentNameDefault = '一级菜单'
t.menu.resource = '授权资源'
t.menu.resourceUrl = '资源URL'
t.menu.resourceMethod = '请求方式'
t.menu.resourceAddItem = '添加一项'
t.menu.label = {}
t.menu.label.closeLeft = '关闭左侧'
t.menu.label.closeRight = '关闭右侧'
t.menu.label.closeOther = '关闭其它'
t.menu.label.closeAll = '全部关闭'


t.role = {}
t.role.name = '名称'
t.role.remark = '备注'
t.role.createDate = '创建时间'
t.role.menuList = '菜单授权'
t.role.deptList = '数据授权'

/* 用户 */
t.user = {}
t.user.username = '用户名'
t.user.deptName = '所属部门'
t.user.email = '邮箱'
t.user.mobile = '手机号'
t.user.status = '状态'
t.user.status0 = '停用'
t.user.status1 = '正常'
t.user.createDate = '创建时间'
t.user.password = '密码'
t.user.comfirmPassword = '确认密码'
t.user.realName = '真实姓名'
t.user.gender = '性别'
t.user.gender0 = '男'
t.user.gender1 = '女'
t.user.gender2 = '保密'
t.user.roleIdList = '角色配置'
t.user.validate = {}
t.user.validate.comfirmPassword = '确认密码与密码输入不一致'
t.user.country = '国家号'
t.user.name = '姓名'
t.user.level = '等级'
t.user.balance = '余额'
t.user.level0 = '未设置'
// t.user.level1 = '代理用户'
// t.user.level2 = '工程用户'
t.user.level10 = 'A级客户'
t.user.level11 = 'A级VIP客户'
t.user.level20 = 'B级客户'
t.user.level21 = 'B级VIP客户'
t.user.level30 = 'C级客户'
t.user.level31 = 'C级VIP客户'
t.user.usable = '可用金额'
t.user.cash = '现金金额'
t.user.present = '赠送金额'
t.user.freeze = '冻结金额'
t.user.point = '积分'
t.user.logout = '注销'
t.user.loginPassword = '登录密码'
t.user.revoke = '撤销'
t.user.grant = '授权'
t.user.usernameTip = '请输入用户名称'

/* 钱包 */
t.wallet = {}
t.wallet.amount = '金额(฿)'
t.wallet.auditAdmin = '审核管理员'
t.wallet.auditTime = '审核时间'
t.wallet.finishAdmin = '完成管理员'
t.wallet.inProgress = '待审核'
t.wallet.agree = '待转账'
t.wallet.refuse = '未通过审核'
t.wallet.finish = '已完成'
t.wallet.agreeButton = '同意'
t.wallet.refuseButton = '拒绝'
t.wallet.transferButton = '转账完成'
t.wallet.Remarks = '备注'
t.wallet.configwithdraw ='确认同意提现?'
t.wallet.configtransfer ='是否确认转账?'
t.wallet.denialReason ='拒绝原因'
t.wallet.viewInfo ='查看转账信息'
t.wallet.bankName ='银行名称'
t.wallet.Account ='账户'
t.wallet.name ='名称'

/* 权限 */
t.power = {}
t.power.role = '角色'
t.power.roleName = '角色名称'
t.power.menu = '菜单'

/* 系统 */
t.sys = {}
t.sys.apk = {}
t.sys.apk.title = '标题'
t.sys.apk.content = '内容'
t.sys.apk.versionName = '版本名称'
t.sys.apk.versionCode = '版本号'
t.sys.apk.pkg = '包名'
t.sys.apk.mandatoryUpdate = '强制更新'
t.sys.apk.file = '文件'
t.sys.apk.all="全部"
t.sys.apk.cearch="搜索"
t.sys.apk.version="新增版本"
t.sys.apk.codeTip="版本名称"
t.sys.apk.mandatoryUpdateTip="是否强制更新-全部"
t.sys.apk.client="客户端-全部"
t.sys.apk.yes='是'
t.sys.apk.no='否'
t.sys.apk.uploadTime='更新时间'
t.sys.apk.kehutype='客户端'
t.sys.apk.mandatoryUpdate='是否强制更新'
t.sys.apk.status='状态'
t.sys.apk.apkoperation='APK操作'
t.sys.apk.forceButton='设为强制更新版本'
t.sys.apk.forceNoButton='设为非强制更新版本'
t.sys.apk.deleteButton='删除版本'
t.sys.apk.reuploadButton='重新上传'
t.sys.apk.modifyButton='修改'
t.sys.apk.updateDescription='更新描述'

t.sys.dict = {}
t.sys.dict.key = '键'
t.sys.dict.value = '值'
t.sys.dict.hint = '说明'
t.sys.dict.search = '键/值/说明'

t.sys.multilingual = {}
t.sys.multilingual.search = '英文/泰文'

t.sys.cache = {}
t.sys.cache.refreshAllCache = '刷新全部缓存'
t.sys.cache.refreshActivityCache = '刷新活动缓存'
t.sys.cache.refreshTagCache = '刷新标签缓存'
t.sys.cache.refreshCarouselCache = '刷新缓存'
t.sys.cache.h5refreshCarouselCache = '刷新H5首页缓存'
t.sys.cache.refreshCategoryCache = '刷新分类缓存'
t.sys.cache.refreshNewCategoryCache = '刷新新分类缓存'

t.sys.cache.refreshActivityCacheSuccess = '刷新活动缓存成功'
t.sys.cache.refreshTagCacheSuccess = '刷新标签缓存成功'
t.sys.cache.refreshCarouselCacheSuccess = '刷新缓存成功'
t.sys.cache.refreshCategoryCacheSuccess = '刷新分类缓存成功'
t.sys.cache.refreshNewCategoryCacheSuccess = '刷新新分类缓存成功'

t.sys.cache.refreshProductCache = '刷新商品缓存'
t.sys.cache.refreshSearchCache = '刷新搜索缓存'
t.sys.cache.refreshProductCacheSuccess = '刷新商品缓存成功'
t.sys.cache.refreshSearchCacheSuccess = '刷新搜索缓存成功'

/**目录**/
t.catalog={}
t.catalog.CATEGORY = '分类'
t.catalog.NEW_CATEGORY = '分类'
t.catalog.ACTIVITY = '活动'
t.catalog.TAG = '标签'
t.catalog.modifySort = '修改排序'
t.catalog.show = '显示'

/**折扣**/
t.discount={}
t.discount.activityId = '活动ID'
t.discount.activityName = '活动名称'
t.discount.activityProfile = '活动介绍'
t.discount.activityTag = '活动标签'
t.discount.activate = '激活'
t.discount.activateOn = '是'
t.discount.activateOff = '否'
t.discount.durationTime = '持续时间'
t.discount.brand = '品牌'
t.discount.brandName = '品牌名称'
t.discount.brandProfile = '品牌介绍'
t.discount.brandInitials  = '品牌首字母'
t.discount.brandLogo = '品牌 Logo'
t.discount.startTime = '开始时间'
t.discount.endTime = '结束时间'
t.discount.productItemPicture = '单品图片'
t.discount.relationActivitys = '关联活动'
t.discount.assure = '品牌认证'
t.discount.address = '发货地址'
t.discount.tips = '提示'
t.discount.deliveryTimeTips = '送货时间提示'
t.discount.paymentType = '支付方式提示'
t.discount.deliveryTimePicture = '送货时间图片'
t.discount.paymentTypePicture = '支付方式图片'
t.discount.allPriceAdjustment = '批量调价'
t.discount.calculateType = '计价类型'
t.discount.calculateValue = '折扣值'
t.discount.timeSetting = '时间设置'
t.discount.deleteSetting = '删除'
t.discount.productName = '商品名称/单品名称/ID'
t.discount.shopName = '店铺名称'
t.discount.skuNum= 'sku数量'
t.discount.baseBigPic = '活动大图'
t.discount.Setrecord = '设置记录'
t.discount.Currentsetting = '当前设置'
t.discount.texttopleft = '品牌折扣页面显示'
t.discount.texttopright = '折扣以下的商品'
t.discount.textconleft = '品牌新品页面显示'
t.discount.day = '天'
t.discount.textconright = '内上架的商品'
t.discount.textbotleft = '品牌折扣页面显示设置'
t.discount.inputtipone = '请输入折扣数'
t.discount.inputtiptwo = '请输入天数'
t.discount.tableone = '折扣显示数值(%)'
t.discount.tabletwo = '新品显示天数(天)'
t.discount.tabletime = '设置时间'
t.discount.tablepeopen = '操作人员'

/**图表**/
t.charts={}
t.charts.dailyUsers = '每日用户'
t.charts.hourlyUsers = '每小时用户'
t.charts.total = '总数'
t.charts.shareCount = '分享数'
t.charts.shareRate = '分享率'
t.charts.dailyOrders = '每日订单'
t.charts.totalCount = '下单总数'
t.charts.totalAmount = '下单总金额'
t.charts.finishedCount = '订单完成数'
t.charts.finishedTotalAmount = '订单完成总金额'
t.charts.finishedRate = '完成率'

/**会员**/
t.member={}
t.member.account = '会员账号'
t.member.relatedCreateTime = '关联创建时间'
t.member.status = '状态'
t.member.yStatus = '绑定'
t.member.nStatus = '异常'
t.member.lowerMemberAccount = '下级会员账号'
t.member.obtainAmount = '会员获取佣金'
t.member.unbinding = '解绑'
t.member.amount = '佣金'
t.member.superiorMemberAccount = '上级会员账号'
t.member.superiorAmount = '新人奖励'
t.member.invitationCode = '邀请码'
t.member.copyInvitationCodeSuccess = '复制成功,当前复制的邀请码是:'
t.member.copyInvitationCodeFailed = '复制失败'
t.member.rewardName = '佣金名称'
t.member.rewardAmount = '金额'
t.member.rewardCreateTime = '时间'
t.member.rewardStatus = '状态'
t.member.rewardAmountAccount = '金额账户'
t.member.yRewardStatus = '正常'
t.member.nRewardStatus = '异常'
t.member.uRewardStatus = '未知'
t.member.newComerAward = '新人'
t.member.pullNewAward = '拉新'
t.member.rewardRecord = '佣金记录'
t.member.firstOrderAward = '新订单奖励'
t.member.Numberaccounts = '子账户数'
t.member.Enteraccountname = '输入子账号名'


/**拉新**/
t.pullnew={}
t.pullnew.currentSetting = '当前设置'
t.pullnew.unlimitedDuration = '无期限'
t.pullnew.newComerAwardAmount = '新人奖励金额 (新用户)'
t.pullnew.pullNewAwardAmount = '拉新奖励金额 (老用户)'
t.pullnew.bindNewComerCount = '绑定新用户数'
t.pullnew.newComerAwardAmountCount = '新人奖励总奖金'
t.pullnew.pullNewAwardAmountCount = '拉新奖励总奖金'
t.pullnew.totalAmountCount = '共'
t.pullnew.queryMore = '查询详情'
t.pullnew.statistics = '统计数据'
t.pullnew.modifySettings = '修改设置'
t.pullnew.modifySettingsNum = '次'
t.pullnew.allBindNewComerCount = '共绑定新用户数'
t.pullnew.showBeforeDetail = '查询往期详情'
t.pullnew.newcomerAmount = '新人奖励'
t.pullnew.pullNewAmount = '拉新奖励'
t.pullnew.totalAmount = '总奖励'
t.pullnew.bindingPullNewActivityEffective = '绑定拉新活动有效'
t.pullnew.bindingNewcomerActivityEffective = '绑定新人活动有效'
t.pullnew.remark = '备注'
t.pullnew.cancel = '取消'
t.pullnew.confirmModify = '确认修改'
t.pullnew.pastRecord = '往期详情'
t.pullnew.time = '时间'

/**分享活动**/
t.member.share={}
t.member.share.tipSmallWordSetting = '标题设置'
t.member.share.promptContentSetting = '提示内容设置'
t.member.share.contentSetting = '内容设置'
t.member.share.isShow = '是否显示'

/**buyfree管理**/
t.buyfree = {}
t.buyfree.add = '添加buyfree'
t.buyfree.productName = '商品名称'
t.buyfree.itemId = '单品ID'
t.buyfree.itemPicture = '单品图片'
t.buyfree.itemName = '单品名称'
t.buyfree.code = 'code'
t.buyfree.brandName = '品牌名称'
t.buyfree.brandLogo = '品牌 Logo'
t.buyfree.rule = '规则'
t.buyfree.startTime = '开始时间'
t.buyfree.endTime = '结束时间'
t.buyfree.numberOfParticipants='参与人数'
t.buyfree.invitationsNumber='邀请人数'
t.buyfree.stock = '库存'
t.buyfree.status = '状态'
t.buyfree.inProgress = '进行中'
t.buyfree.closed = '已结束'
t.buyfree.itemOff = '下架'
t.buyfree.details = '查看'
t.buyfree.activityTime = '活动时间'
t.buyfree.pullNewOnly = '仅拉新'
t.buyfree.pullNewNumber = '拉新人数'
t.buyfree.coExistWithPullNew = '是否与拉新共存'
t.buyfree.isNewPull = '是否拉新活动'
t.buyfree.isParallel = '是否可以同时参加其他活动'
t.buyfree.ruleDescription = '规则说明'
t.buyfree.pageRuleDescription = '页面规则说明'
t.buyfree.activityOff = '下架活动'
t.buyfree.todayNewParticipantsNumber = '今日新增参与活动人数'
t.buyfree.totalNumber = '总参与人数'
t.buyfree.totalPullNewNumber = '总拉新人数'
t.buyfree.totalReward = '全部奖励'
t.buyfree.rewardedUsers = '已获得奖励用户'
t.buyfree.surplusStock= '剩余库存'
t.buyfree.userName = '用户账户'
t.buyfree.participateTime = '参与时间'
t.buyfree.completion = '完成度'
t.buyfree.lastPullNewTime = '最后拉新时间'
t.buyfree.userAccount = '用户账户'
t.buyfree.activityPullNewDetails = '活动拉新详情'
t.buyfree.binddingTime = '绑定时间'
t.buyfree.buyfreeType = '活动类型'
t.buyfree.buyfreeTypeForBuyfreeKey = 'Buyfree活动'
t.buyfree.buyfreeTypeForBuyfreeDraw = '摇一摇活动'

/**
 * 摇一摇
 */
t.shake= {}
t.shake.add = '添加摇一摇'
t.shake.shakeData = '数据'
t.shake.shakeRule = '规则'
t.shake.next = '下一步'
t.shake.before = '上一步'
t.shake.activityData = '活动数据'
t.shake.activityName = '活动名称'
t.shake.logo = 'LOGO图标'
t.shake.coverLogo = '封面图标'
t.shake.ruleDescription = '规则说明'
t.shake.defaultData = '默认数据'
t.shake.backgroundPicture = '背景图片'
t.shake.shakePicture = '摇一摇图片'
t.shake.decorationPicture = '装饰图片'
t.shake.shakeGIF = '摇一摇GIF'
t.shake.notWinningText = '不中奖文本'
t.shake.winningText = '中奖文本'
t.shake.notWinningPicture = '不中奖图片'
t.shake.winningSmallPicture = '中奖小图'
t.shake.notWinningSmallPicture = '不中奖小图'
t.shake.settingPrize = '设置奖品'
t.shake.prizeType = '奖品类型'
t.shake.prizeName = '奖品名称'
t.shake.prizeLevel = '奖品等级'
t.shake.prizeCount = '奖品数量'
t.shake.baseWinningRate = '基础中奖率'
t.shake.setTimeWinningRate = '根据时间设置中奖率'
t.shake.tips = '提示文本'
t.shake.remark = '备注'
t.shake.setTime = '时间'
t.shake.addTimes = '添加时间'
t.shake.lotteryNumber = '抽奖次数'
t.shake.lotteryAllNumber = '抽奖总次数'
t.shake.personEverydayLotteryNumber = '每天每日次数'
t.shake.personAllLotteryNumber = '每人总次数'
t.shake.inputCount = '输入次数'
t.shake.productItem = '单品'
t.shake.wallet = 'wallet'
t.shake.amount = '金额'
t.shake.addPrize = '添加奖品'
t.shake.addMoney = '添加金额'
t.shake.sort = '排序'
t.shake.awardType = '中奖类型'
t.shake.awardTypeNORMAL = '普通'
t.shake.awardTypeSINGLE_MUTEX = '单个互斥'
t.shake.awardTypeMULT_MUTEX = '多个互斥'
t.shake.awardTypeALL_MUTEX_DAY = '每天中奖互斥'
t.shake.ruleName = '规则名称'
t.shake.havekey = '激活口令'
t.shake.key = '口令'
t.shake.closeAndReset = '关闭将清空未保存的数据'
t.shake.chooseRule = '选择规则'
t.shake.chooseRuleType1 = '全时间段'
t.shake.chooseRuleType2 = '时间段'
t.shake.chooseRuleType3 = '每天时间段'
t.shake.chooseRuleType4 = '日期时间段'
t.shake.limitAwardTimes = '限制中奖次数'
t.shake.ruleContent = '规则内容'
// t.shake.tips = '请往右拉看看规则是否填写完!'



/** 轮播视频 */
t.video={}
t.video.name = '视频名称'
t.video.video = '视频'
t.video.createTime = '创建时间'
t.video.remark = '备注'
t.video.sort = '排序'
t.video.status = '状态'
t.video.itemOff = '下架'
t.video.itemOn = '上架'
t.video.delete = '删除'
t.video.description = '描述'
t.video.statusShow = '显示'
t.video.statusHide = '隐藏'
t.video.upload = '视频上传'
t.video.uploadEx = '视频上传失败，请重新上传!'
t.video.noSupport = '您的浏览器不支持视频播放'
t.video.noUpload = '请上传视频'

/** 新首页 */

/** 标签 */
t.homepage = {}
t.homepage.carousel = '首页轮播图'
t.homepage.tags = '首页标签'
t.homepage.activities = '活动'
t.homepage.jumpEditor = '跳转编辑'
t.homepage.taglist = {}
t.homepage.taglist.id = '标签ID'
t.homepage.taglist.tagName = '标签名称'
t.homepage.taglist.icon = '图标'
t.homepage.taglist.createTime = '创建时间'
t.homepage.taglist.jumpType = '跳转类型'
t.homepage.taglist.remark = '备注'
t.homepage.taglist.contentQuantity = '内容数量'
t.homepage.taglist.sort = '排序'
t.homepage.taglist.status = '状态'
t.homepage.taglist.inProgress = '进行中'
t.homepage.taglist.closed = '已结束'
t.homepage.taglist.off = '已下架'
t.homepage.taglist.itemOff = '下架'
t.homepage.taglist.itemOn = '上架'
t.homepage.taglist.cancelRelated = '取消关联'
t.homepage.taglist.modifySort = '修改排序'
t.homepage.taglist.content = '内容'
t.homepage.taglist.engIcon = '标签图标(EN)'
t.homepage.taglist.thIcon = '标签图标(TH)'
t.homepage.taglist.jumpTypeForMONOPOLY = '活动专场'
t.homepage.taglist.jumpTypeForH5 = 'H5'
t.homepage.taglist.jumpTypeForURL = 'Url'
t.homepage.taglist.jumpTypeForBUYFREE = 'buyfree活动列表'
t.homepage.taglist.jumpTypeForBUYFREEDETAIL = 'buyfree活动ID'
t.homepage.taglist.jumpTypeForMEMBER = '会员界面'
t.homepage.taglist.jumpTypeForWALLTE = '电子钱包界面'
t.homepage.taglist.jumpTypeForLOGIN = '登录界面'
t.homepage.taglist.typeItemId = '类型ID'
t.homepage.taglist.addContent= '添加内容'
t.homepage.taglist.contentAdded = '已添加内容'
t.homepage.taglist.addProduct = '添加商品'
t.homepage.taglist.addedProductItem = '已添加商品'
t.homepage.taglist.ableAddProductItem = '可添加商品'
t.homepage.taglist.addSpecialActivities = '添加专场'
t.homepage.taglist.addedSpecialActivity = '已添加专场'
t.homepage.taglist.ableAddSpecialActivity = '可添加专场'
t.homepage.taglist.addAdvertising = '新增广告'
t.homepage.taglist.addHotSaleProduct = '新增热销产品'
t.homepage.taglist.add = '添加'
t.homepage.taglist.remove = '移除'
t.homepage.taglist.Allremove = '全部移除'
t.homepage.activity = {}
t.homepage.activity.logo = 'LOGO/图标'
t.homepage.activity.remark = '备注'
t.homepage.activity.title = '标题'
t.homepage.activity.sku = 'sku'
t.homepage.activity.attribute = '属性'
t.homepage.activity.attributeValue = '属性值'
t.homepage.activity.stock = '库存'
t.homepage.activity.backgroundPicture = '背景图'
t.homepage.activity.tag = '专场/标签'
t.homepage.activity.type = '类型'
t.homepage.activity.sort = '排序'
t.homepage.activity.status = '状态'
t.homepage.activity.advert = 'H5广告'
t.homepage.activity.hotsales = '热卖商品'
t.homepage.activity.product = '单品'
t.homepage.activity.activity = '活动'
t.homepage.activity.activityPicture = '图片活动'
t.homepage.activity.tagSort = '标签排序'
t.homepage.activity.tagStatus = '标签状态'
t.homepage.activity.isHomePage = '是否首页'
t.homepage.activity.homePageSort = '首页排序'
t.homepage.activity.statusEnable = '有效'
t.homepage.activity.statusDisable = '无效'
t.homepage.activity.bulkOperations = '批量操作 已选中 '
t.homepage.hotsale = {}
t.homepage.hotsale.name = '名称'
t.homepage.hotsale.engBackgroundPicture = '背景图片(EN)'
t.homepage.hotsale.thBackgroundPicture = '背景图片(TH)'
t.homepage.specialactivity = {}
t.homepage.specialactivity.logo = 'LOGO'
t.homepage.specialactivity.name = '名称'
t.homepage.specialactivity.brandTitle = '品牌'
t.homepage.specialactivity.title = '标题' 
t.homepage.specialactivity.describe = '描述'
t.homepage.specialactivity.backgroundPicture = '背景图'
t.homepage.specialactivity.coverPicture = '封面图'
t.homepage.specialactivity.tags = '专场/标签' 
t.homepage.specialactivity.type =  '类型'
t.homepage.specialactivity.status = '状态'
t.homepage.specialactivity.name = '名称'
t.homepage.specialactivity.activity = '活动'
t.homepage.specialactivity.isHomePage = '是否首页展示'
t.homepage.specialactivity.relatedTags = '关联标签'
t.homepage.specialactivity.Listtitle = '列表标题'
t.homepage.specialactivity.Searchkey = '搜索关键字'
t.homepage.specialactivity.Catalog = '目录'
t.homepage.specialactivity.alllistproduct = '全部商品列表'
t.homepage.specialactivity.Catalogitemlist = '目录商品列表'
t.homepage.specialactivity.Searchproductlist = '搜索商品列表'

t.merchant = {}
t.merchant.name = '商家名称'
t.merchant.intro = '商家介绍'
t.merchant.mobile = '商家电话'
t.merchant.account = '商家账号'
t.merchant.passwd = '商家密码'
t.merchant.merchantId = '商家'
t.merchant.accountList = '商家账号列表'
t.merchant.company = '商家公司'
t.merchant.logo = '商家Logo'
t.merchant.code = '店铺编号'
t.merchant.email = '店铺email'
t.merchant.nameIsExistTips = '当前店铺名称已经存在,请更换一个试试'
t.merchant.nameIsNotExistTips = '当前店铺名称可用'

t.categorynew = {}
t.categorynew.addfirstClass="新建一级分类"
t.categorynew.Multilingualname="多语言名称"
t.categorynew.activation="激活"
t.categorynew.firstName="一级分类名称"
t.categorynew.firstsorting="一级分类排序"
t.categorynew.newdirectory="新建目录"
t.categorynew.Directoryname="目录名称"
t.categorynew.Relatedcommodities="关联商品"
t.categorynew.skuCount="关联SKU数"

/**共用**/
t.public={}
t.public.set = '设置'
t.public.settings = '设置'
t.public.edit = '编辑'
t.public.clickToEdit = '点击编辑'
t.public.add = '添加'
t.public.details='详情'
t.public.delete = '删除'
t.public.update = '更新'
t.public.modify = '修改'
t.public.success = '成功'
t.public.fail = '失败'
t.public.error = '错误'
t.public.sort = '排序'
t.public.tips = '提示'
t.public.operation = '操作'
t.public.yes = '是'
t.public.no = '否'
t.public.submit = '提交'
t.public.reset = '重置'
t.public.confirm = '确认'
t.public.cancel = '取消'
t.public.back = '返回'
t.public.title = '标题'
t.public.content = '内容'
t.public.picture = '图片'
t.public.search = '搜索'
t.public.query = '查询'
t.public.output = '导出'
t.public.icon = '图标'
t.public.selectedIcon = '选中图标'
t.public.askDelete = '此操作将被永久删除。是否继续?'
t.public.chinese = '中文'
t.public.english = '英文'
t.public.thai = '泰文'
t.public.createTime = '创建时间'
t.public.finishTime = '完成时间'
t.public.status = '状态'
t.public.valid = '有效'
t.public.invalid = '无效'
t.public.iSee = '我知道了'
t.public.close = '关闭'
t.public.remark = '备注'
t.public.value = '值'
t.public.baseInformation = '基本信息'
t.public.all = '所有'
t.public.name = '名称'
t.public.numberSort = '请输入数值越大越排前'
t.public.advert = '广告'
t.public.profile = '介绍'
t.public.backgroundPicture = '背景图片'
t.public.Initials = '首字母'
t.public.price = '价格'
t.public.resetSearchKeyword = '重置搜索词库'
t.public.product = '单品'
t.public.onShelves = '已上架'
t.public.offShelf = '已下架'
t.public.prohibit = '禁用'
t.public.enable = '启用'










t.order.label = {}
t.order.label.all = '全部'
t.order.label.waitForAuditing = '待审核'
t.order.label.waitForPay = '待支付'
t.order.label.waitForDelivery = '待发货'
t.order.label.waitForReceive = '待收货'
t.order.label.canceled = '取消'
t.order.label.finished = '已完成'
t.order.label.orderId = '订单ID'
t.order.label.username = '用户名'
t.order.label.productCode = '单品Code'
t.order.label.productKeywords = '单品关键字'
t.order.label.orderCode = '订单详情'
t.order.label.shippingDetails = '收货信息'
t.order.label.paymentDetails = '支付详情'
t.order.label.orderCode = '订单编号'
t.order.label.orderChannel = '下单渠道'
t.order.label.customerName = '顾客名称'
t.order.label.priceTier = '价格区间'
t.order.label.paymentStatus = '支付状态'
t.order.label.paymentMethods = '支付方式'
t.order.label.createTime = '订单提交时间'
t.order.label.confirmTime = '订单确认时间'
t.order.label.finishTime = '订单完成时间'
t.order.label.productInfo = '产品信息'
t.order.label.productName = '商品名称'
t.order.label.productProperty = '产品属性'
t.order.label.orderInfo = '订单信息'
t.order.label.logisticsInfo = '物流信息'
t.order.label.orderStatus = '订单状态'
t.order.label.contactName = '收货人'
t.order.label.address = '收货地址'
t.order.label.mobile = '手机'
t.order.label.contractNo = '电话'
t.order.label.receiveRemark = '用户留言'
t.order.label.companyName = '公司'
t.order.label.historyOrder = '历史订单'
t.order.piclargetip='*大小不得超过3MB，格式为png、jpg、jpeg'
t.order.picerror='图片格式错误'
t.order.piclarge='图片过大'

t.order.label.operation = '操作'
t.order.label.productType = '货品种类'
t.order.label.count = '数量总计'
t.order.label.clickToShowPrefix = '点击查看(共'
t.order.label.clickToHidePrefix = '点击隐藏(共'
t.order.label.clickToShowSuffix = '个产品)'
t.order.label.clickToHideSuffix = '个产品)'
t.order.label.copy = '复制'
t.order.label.ViewOrderDetail = '查看订单详情'
t.order.label.confirmArriveDate = '发送交期'
t.order.label.confirmPaid = '确认已支付'
t.order.label.confirmPaidFront = '确认已预付款'
t.order.hint = {}
t.order.hint.copySuccess = '复制成功'
t.order.hint.copyFail = '复制失败'
t.order.hint.arriveDateEmpty = '请选择交期'
t.order.hint.freightPlease = '请输入运费'

t.order.label.productInfoAndPrice = '商品 单价'
t.order.label.productCount = '数量'
t.order.label.productPrice = '价格'
t.order.label.orderStatus = '货物状态'

t.order.label.goodsAmount = '商品金额'
t.order.label.freightAmount = '运费总计'
t.order.label.totalAmount = '货物总金额'

t.order.confirmContent = {}
t.order.confirmContent.level10 = '敬爱的客户,您好!\n        根据您提交的订单,我们根据货物的预计调货以及物流时间,确认预计交期如下:\n \n                                                                            #ARRIVEDATE#\n \n        鉴于您良好的信用,我们将会为您垫付款项,请于交期准备好现金或信用卡支付.'
t.order.confirmContent.level11 = t.order.confirmContent.level10
t.order.confirmContent.level1 = t.order.confirmContent.level11
t.order.confirmContent.level20 = '敬爱的客户,您好!\n        根据您提交的订单,我们根据货物的预计调货以及物流时间,确认预计交期如下:\n \n                                                                            #ARRIVEDATE#\n \n        鉴于您良好的信用,请于#PAYDAYS#天内完成付款,剩余款项待货物交付后补齐,否则订单将会自动取消.'
t.order.confirmContent.level21 = t.order.confirmContent.level20
t.order.confirmContent.level30 = '敬爱的客户,您好!\n        根据您提交的订单,我们根据货物的预计调货以及物流时间,确认预计交期如下:\n \n                                                                            #ARRIVEDATE#\n \n        鉴于您良好的信用,请于#PAYDAYS#天内预付款 ฿ #AMOUNT#,剩余款项待货物交付后补齐,否则订单将会自动取消.'
t.order.confirmContent.level31 = t.order.confirmContent.level30
t.order.label.selectArriveDate = '选择交期'
t.order.label.Enterfreight = '输入运费'
t.order.label.modifyArriveDate = '修改交期'
t.order.label.modifyContent = '修改默认文案'
t.order.label.modifyPayDays = '修改默认付款天数'
t.order.label.modifyPayAmountRate = '修改默认首付比例'
t.order.label.selectCountPrefix = '共选中'
t.order.label.selectCountSuffix = '个商品,批量操作:'
t.order.label.outOfStock = '批量缺货'
t.order.label.halfConfirm = '部分发货'
t.order.label.confirm = '确认发送'
t.order.label.cancel = '取消'
t.order.label.remark = '备注'
t.order.label.sendMessage = '留言'
t.order.label.confirmOrder = '订单确认'
t.order.label.step = '进度'
t.order.label.confirmToDeliver = '确认发货'

t.order.hint.hadPaidFront = '用户是否已预付款'
t.order.hint.hadPaidRest = '用户是否已付尾款'
t.order.hint.hadPaid = '用户是否已付款'
t.order.label.hadPaid = '已付款'
t.order.label.payAmount = '付款金额'
t.order.label.paymenntTip='上传支付凭证：'

t.order.label.cancelOrder = '取消订单'

t.order.unit = {}
t.order.unit.productType = '种'
t.order.unit.productCount = '件'

t.order.search = {}
t.order.search.inputHint = '请输入...'
t.order.search.selectHint = '请选择...'

t.order.step = {}
t.order.step.createOrder = '提交订单'
t.order.step.confirmOrder = '确认订单'
t.order.step.confirmPaidFront = '预付款'
t.order.step.confirmPaidRest = '付尾款'
t.order.step.delivered = '运输中'
t.order.step.receipt = '已签收'
t.order.step.confirmPaid = '付款'
t.order.step.finished = '已完成'

t.order.dearCustomerHello='尊敬的客户,你好!'
t.order.orderamendedasfollows='订单修改如下：'
t.order.changeinto='修改为'

t.order.COMMITED = '已提交'
t.order.WAP = '待预付'
t.order.WFP = '待付尾款'


t.member.label = {}
t.member.label.audit = '用户审核'
t.member.label.username = '用户名称'
t.member.label.mobile = '用户手机号'
t.member.label.phoneNo = '用户座机'
t.member.label.companyName = '公司名称'
t.member.label.userLevel = '用户等级'
t.member.label.createTime = t.user.createDate
t.member.label.status = t.user.status
t.member.label.operation = t.user.status
t.member.value = {}
t.member.value.statusY = '正常'
t.member.value.statusN = '停用'
t.member.value.statusU = '未审核'
t.member.label.showDetail = '查看详情'
t.member.label.createUser = '创建用户'
t.member.label.userDetail = '用户详情'



t.order.label.hadReceived = '用户已收货'
t.order.hint.hadReceived = '用户是否已收货'
t.order.hint.minProductCountLimit = '商品数据少于起订数'
t.member.label.baseInfo = '用户基本信息'
t.member.label.platformId = '平台ID'
t.member.label.companyName = '公司名称'
t.member.label.companyTaxno = '公司税务号'
t.member.label.contractName = '联系人姓名'
t.member.label.mobile = '联系电话'
t.member.label.phoneNo = '固定电话'
t.member.label.email = '邮箱'
t.member.label.platformInfo = '用户平台信息'
t.member.label.username = '用户账号'
t.member.label.password = '用户密码'
t.member.label.level = '用户等级'
t.member.label.otherInfo = '其他信息'
t.member.label.totalAmount = '总交易额'
t.member.label.orderCount = '下单总次数'
t.member.label.availOrderCount = '有效订单数'
t.member.label.lastOrderTime = '最近交易时间'
t.member.label.lastOrderAmount = '最近订单金额(฿)'
t.member.label.orderProductCount = '采购商品数量'
t.member.label.refuse = '拒绝'
t.member.label.agree = '同意申请'

t.product.label = {}
t.product.label.editPrice = '修改价格'
t.product.label.priceAndStock = '价格与库存'
t.product.label.priceLevel10 = 'A级客户价格'
t.product.label.priceLevel11 = 'A级客户VIP价格'
t.product.label.priceLevel20 = 'B级客户价格'
t.product.label.priceLevel21 = 'B级客户VIP价格'
t.product.label.priceLevel30 = 'C级客户价格'
t.product.label.priceLevel31 = 'C级客户VIP价格'
t.product.label.originalprice = '零售价'
t.product.label.priceCost = '成本价'
t.product.label.operationfee = '分销操作费'
t.product.label.total = '库存'
t.product.label.stock = '增量'
t.product.label.minCount = '起订量'
t.product.itemAdded = '已添加商品'
t.product.canAddGoods = '可添加商品'
t.product.Timeofreceipt = '收货时间'
t.product.Cancellationtime = '取消时间'
t.product.Operatingfee = '操作费'
t.product.Totalorderprice = '订单总价'
t.product.Checkoutstatus = '结账状态'
t.product.Checkouttime = '结账时间'
t.product.priceVal = '价格是否确认为0?'



t.category = {}
t.category.label = {}
t.category.label.category = '分类'
t.category.label.categoryName = '分类名'
t.category.label.append = '添加'
t.category.label.relation = '关联'
t.category.label.unrelation = '取消关联'
t.category.label.update = '修改'
t.category.label.delete = '删除'
t.category.label.sort = '排序'
t.category.label.advert = '广告'
t.category.label.cover = '封面图'
t.category.label.nameLevel1 = '一级分类'
t.category.label.nameLevel2 = '二级分类'
t.category.label.nameLevel3 = '三级分类'

t.category.label.relationDetail = '关联详情'
t.public.filter = '筛选'
t.category.label.batchAddPrefix = '批量操作 已选中'
t.category.label.skuProportion = '有效SKU/总数'

t.category.label.off = '下架'
t.category.label.on = '上架'

t.catalog.merchant = {}
t.catalog.merchant.itemAdded = '已添加店铺'
t.catalog.merchant.canAddItems = '可添加店铺'

t.merchant.label = {}
t.merchant.label.name = '店铺名称'
t.merchant.label.company = '店铺公司'
t.merchant.label.intro = '店铺介绍'
t.merchant.label.desc = '店铺描述'
t.merchant.label.mobile = '店铺电话'
t.merchant.label.email = '店铺邮件'
t.merchant.suppliernameTip = '请输入供应商姓名'


t.product.Pricerange = 'Price range'
t.product.Inventoryinterval = 'Inventory interval'
t.category.commodityCategory = 'Commodity category'

// t.member.label.accountDays = 'Pay delay(days)'
t.order.label.fee = 'Handling Fee or Bankcharge'
t.product.label.overseasStock = 'Overseas stock'
t.member.label.modifyPassword = 'Modify password'
t.member.label.verifyPassword = 'Verify password'
t.validate.passwordNotMatch = 'The verify password is not match'

t.user.accountDayPrefix = '-'
t.user.accountDaySuffix = 'Days credit terms'
t.member.label.accountDays = 'Credit terms'
t.member.label.settingAccountDaysSuffix = ' Day'
t.member.label.accountDaysSuffix = 'Days credit terms'
t.member.label.zeroAccountDays = 'No credit terms'
t.order.label.outtimeForPayPrefix = 'Please advise the payment as soon as possible, only '
t.order.label.outtimeForPaySuffix = ' from deadline'

t.order.label.prepaymentAmount = 'Advance Payment Amount'
t.order.label.finalPaymentAmount = 'Final payment Amount'
t.order.label.paid = 'Paid'
t.order.label.unpaid = 'Unpaid'
t.order.label.paidStatus = 'Status'

t.product.item.overseasTotal = 'Overseas stock'

t.brandPage={}
t.brandPage.addBrand = '添加品牌'
t.brandPage.brand = '品牌'
t.brandPage.show = '上下架状态'
t.brandPage.Brandname='品牌名称'
t.brandPage.Brandlogo='品牌logo'
t.brandPage.SKUstotal='有效SKU数/总SKU数'
t.brandPage.Newbrand='新增品牌'
t.brandPage.Modifybrand='修改品牌'
t.brandPage.Dummyvalue='虚拟值'
t.brandPage.Editfirstcategory='编辑一级分类 --'
t.brandPage.Addnewcategory='新增一级分类'
t.brandPage.Clickicon='点击效果图标'
t.brandPage.iconnotclicked='未点击效果图标'
t.brandPage.showinthecategory='是否展示在分类里'
t.brandPage.Adspictures='广告图'
t.brandPage.Editsendcategory='编辑二级分类 --'
t.brandPage.Addsendcategory='新增二级分类'
t.brandPage.Editthildcategory='编辑三级分类 --'
t.brandPage.Addthildcategory='新增三级分类'
t.brandPage.Relatedinformation='关联信息'
t.brandPage.relatedproducts='关联产品'
t.brandPage.CategoryName='分类名称'
t.brandPage.videoformat='请上传正确的视频格式'
t.brandPage.recommandSize1 = '推荐尺寸800X800px以上，png、jpg格式，不超过5M'
t.brandPage.recommandSize2 = '推荐尺寸1080 X 320px以上，png、jpg格式，不超过5M'
t.brandPage.recommandSize3 = '推荐尺寸800X800px以上，png、jpg格式，不超过5M'
t.brandPage.sider={}
t.brandPage.sider.inputName='请输入品牌名称'
t.brandPage.sider.brandName='品牌名称'
t.brandPage.sider.brandImg='品牌图片'
t.brandPage.sider.brandAdvImg='品牌广告'
t.brandPage.sider.brandContact='品牌联系人'
t.brandPage.sider.brandPhone='电话'
t.brandPage.sider.skuratio='有效SKU / 总SKU'
t.brandPage.sider.brandMail='邮件'
t.brandPage.sider.sort='排序'

export default t

